export default {

  data: () => ({
    mask: {
      cpfCnpj: ['###.###.###-##', '##.###.###/####-##'],
      cnpj: '##.###.###/####-##',
      cep: '##.###-###',
      cpf: '###.###.###-##',
      date: '##/##/####',
      phone: '(##) ####-####',
      celPhone: '(##) #####-####'
    },
    money: {
      decimal: ',',
      thousands: '.',
      // prefix: 'R$ ',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: false /* doesn't work with directive */
    }
  })
}
